import { render, staticRenderFns } from "./_base-autosuggest.vue?vue&type=template&id=3700b592&"
import script from "./_base-autosuggest.vue?vue&type=script&lang=js&"
export * from "./_base-autosuggest.vue?vue&type=script&lang=js&"
import style0 from "./_base-autosuggest.vue?vue&type=style&index=0&id=3700b592&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports